import { TruckSubheaderWrapper } from "./TruckSubheader.styles";
import { SaveTruckText, SearchTruckOrdersText } from "constants/text";
import SaveOutlined from "@mui/icons-material/SaveOutlined";
import { SaveDraftButton } from "components/NewOrders/SaveDraft/SaveDraft.styles";
import SuggestedSearch from "components/Common/SuggestedSearch/SuggestedSearch";
import { SyntheticEvent } from "react";

interface TruckSubheaderProps {
	title: string;
	showSaveButton?: boolean;
	handleSaveTruck?: () => Promise<void>;
	searchOptions?: any[];
	handleDraftSearch?: (_event: SyntheticEvent, values: string | null) => void;
	searchValue?: string | null;
}

const TruckSubheader = ({
	title,
	handleSaveTruck,
	searchOptions,
	handleDraftSearch,
	showSaveButton = true,
	searchValue
}: TruckSubheaderProps) => {
	return (
		<TruckSubheaderWrapper data-testid="truck-subheader">
			<h5>{title}</h5>
			{showSaveButton && (
				<div>
					<SaveDraftButton
						variant="text"
						onClick={handleSaveTruck}
						data-testid="save-truck-button"
					>
						<SaveOutlined />
						{SaveTruckText}
					</SaveDraftButton>
					{searchOptions && (
						<SuggestedSearch
							ariaLabel="Search Truck Orders"
							dataTestId="search-truck-orders"
							id="search-truck-orders"
							placeholder={SearchTruckOrdersText}
							handleSearch={(_event: SyntheticEvent, values: string | null) =>
								handleDraftSearch?.(_event, values)
							}
							searchOptions={searchOptions}
							dropDownOpenOnChar={1}
							searchValue={searchValue ?? ""}
							size="small"
						/>
					)}
				</div>
			)}
		</TruckSubheaderWrapper>
	);
};

export default TruckSubheader;
